import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { getDissertation } from "./dissertation.api";
import { DashboardLayout } from "@/app/layout/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { routes } from "@/app/routes/paths";
import DashboardSkeleton from "@/components/DashboardSkeleton";
import { DissertationSubmissionForm } from "./form";
import useGcpsUIController from "@/hooks/useGlobalContext";
import { DissertationClosedPage } from "./DissertationClosedPage";

export const DissertationPage = () => {
	const { controller } = useGcpsUIController();
	const { config } = controller;
	const navigate = useNavigate();

	const { data, isLoading } = useQuery({
		queryKey: ["dissertation"],
		queryFn: getDissertation,
		refetchOnWindowFocus: false,
	});

	useEffect(() => {
		if (data?.data && !data?.data?.resubmission_enabled) {
			navigate(routes.DISSERTATION_DETAILS_PATH);
		}
	}, [data, navigate]);

	if (isLoading || data?.data && !data?.data?.resubmission_enabled) {
		return (
			<DashboardLayout>
				<DashboardSkeleton />
			</DashboardLayout>
		);
	}

	if (config && !config?.global?.isDissertationSubmissionOpen && !data?.data?.resubmission_enabled) {
		return (
			<DashboardLayout>
				<div className="mx-auto w-full max-w-2xl py-10">
					<DissertationClosedPage period={config?.global?.academic_period} />
				</div>
			</DashboardLayout>
		);
	}

	return <DissertationSubmissionForm dissertation={data?.data ?? null} />;
};
